// src/pages/Shipments/helpers/statusFromParam.ts
import { ShipmentStatus } from '@/constants/shipment';

const VALID = new Set<string>(
  Object.values(ShipmentStatus).filter((s) => s !== ShipmentStatus.All),
);

export function statusFromParam(raw: string | null): ShipmentStatus | undefined {
  if (!raw) return undefined;
  return VALID.has(raw) ? (raw as ShipmentStatus) : undefined;
}
